import { render, staticRenderFns } from "./TipoVehiculoModalNuevo.vue?vue&type=template&id=1bcf3e74&scoped=true&"
import script from "./TipoVehiculoModalNuevo.vue?vue&type=script&lang=ts&"
export * from "./TipoVehiculoModalNuevo.vue?vue&type=script&lang=ts&"
import style0 from "./TipoVehiculoModalNuevo.vue?vue&type=style&index=0&id=1bcf3e74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcf3e74",
  null
  
)

export default component.exports